var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"game",attrs:{"large":""},on:{"close":_vm.closeGame}},[(_vm.gameDetailId)?_c('game',{attrs:{"slot":"content","id":_vm.gameDetailId,"list-id":_vm.gameDetailListIndex},slot:"content"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3638c6e2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameBoard/GameModal.vue
// module id = null
// module chunks = 